import { createFileRoute } from '@tanstack/react-router'

interface IMessagesSearch {
  page?: number
  sortBy?: string
  sortDir?: 'asc' | 'desc'
  messageId?: string
}

export const Route = createFileRoute('/_authenticated/messages')({
  validateSearch: (search: Record<string, unknown>): IMessagesSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
    sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
    sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
    messageId: typeof search.messageId === 'string' && search.messageId.length > 0 ? search.messageId : undefined,
  }),
})
